import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import authComponent from "@/components/auth/authComponent.vue";
import LoginPage from "@/components/auth/LoginPage.vue";
import ForgottenPassword from "@/components/auth/ForgottenPassword.vue";
import ResetPassword from "@/components/auth/ResetPassword.vue";
import VerifyEmail from "@/components/auth/VerifyEmail.vue";
import VerifyUser from "@/components/auth/VerifyUser.vue";
import RegisterComponent from "@/components/auth/RegisterComponent.vue";
import GuestDashboard from "@/components/Dashboard/GuestDashboard.vue";
import AdminDashboard from "@/components/Dashboard/AdminDashboard.vue";
import TermsComponent from "@/components/auth/TermsComponent.vue";
import PolicyComponent from "@/components/auth/PolicyComponent.vue";
import ListingsView from "@/views/ListingsView.vue";
import ListingDetailView from "@/components/Listings/ListingDetailView.vue";
import UsersView from "@/views/UsersView.vue";
import DashboardView from "@/views/DashboardView.vue";
import CategoriesView from "@/views/CategoriesView.vue";
import SubcategoriesView from "@/views/SubcategoriesView.vue";
import GroupsView from "@/views/GroupsView.vue";
import SectionView from "@/views/SectionsView.vue";
import RolesView from "@/views/RolesView.vue";
import PermissionsView from "@/views/PermissionsView.vue";
import CountriesView from "@/views/CountriesView.vue";
import CitiesView from "@/views/CitiesView";
import TransactionsView from "@/views/TransactionView.vue";
import PlaceAd from "@/views/PlaceAd.vue";
import ListingCost from "@/views/ListingCostView.vue";
import AdminLoginPage from "@/components/auth/AdminLoginPage.vue";
import ProductView from "@/views/ProductView.vue";
import MyNotifications from "@/views/MyNotifications.vue";
import ChatView from "@/views/ChatView.vue";
import MyAds from "@/views/MyAds.vue";
import FavoritesComponent from "@/components/FavoritesComponent.vue";
import store from "@/store"; // Import the Vuex store

// 🏍️ Motors & Subcategories
//import PickSubCategory from "@/components/PickSubCategory.vue"; // Corrected case sensitivity
// import CarsComponent from "@/components/subcategories/CarsComponent.vue";
// import MotorcyclesComponent from "@/components/subcategories/MotorcyclesComponent.vue";
import SelectYourCity from "@/views/SelectYourCity.vue";
import CarSignUpForm from "@/components/CarSignUpForm.vue";
import ListingsReportedView from "@/views/ListingsReportedView.vue";
import JobsPageComponent from "@/components/Jobs/JobsPageComponent.vue";
import OverviewPage from "@/components/Dashboard/OverviewPage.vue";
import JobsDashboard from "@/components/Dashboard/JobsDashboard.vue";
import CandidateSearch from "@/components/Dashboard/CandidateSearch.vue";
import Profile from "@/components/Jobs/Profile/Candidate/Profile.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: HomeView,
    // meta: { title: "Home" }, // Root breadcrumb
  },
  // 📌 Motors & Subcategories
  {
    path: "/pick-subcategory/:subcategory",
    name: "PickSubCategory",
    component: () => import("@/components/PickSubCategory.vue"),
    meta: {
      title: (route) =>
        route.params.subcategory.charAt(0).toUpperCase() +
        route.params.subcategory.slice(1), // Dynamically set the category name
      parent: "PlaceAd",
    },
  },

  {
    path: "/car-signup",
    name: "CarSignUpForm",
    component: CarSignUpForm,
    meta: { title: "Car Sign Up", parent: "SubcategoryList" }, // Child of Subcategories
  },

  {
    // Change from /group-list/11?categoryId=4 to /group-list/subcategory-name
    path: "/group-list/:subcategorySlug",
    name: "GeneralGroupsListComponent",
    component: () => import("@/components/GeneralGroupsListComponent.vue"),
    props: (route) => ({
      subcategorySlug: route.params.subcategorySlug,
      categorySlug: route.query.category,
    }),
    meta: {
      title: (route) => `Select Group`,
      parent: "PickSubCategory",
    },
  },
  {
    // Change from /section-list/33 to /section-list/group-name
    path: "/section-list/:groupSlug",
    name: "GeneralSectionsListComponent",
    component: () => import("@/components/GeneralSectionsListComponent.vue"),
    props: (route) => ({
      groupSlug: route.params.groupSlug,
      categorySlug: route.query.category,
      subcategorySlug: route.query.subcategory,
    }),
    meta: {
      title: (route) => `Select Section`,
      parent: "GeneralGroupsListComponent",
    },
  },
  {
    // Change from /listing-signup/4/11/33 to /listing-signup/category/subcategory/group/section
    path: "/listing-signup/:categorySlug?/:subcategorySlug?/:groupSlug?/:sectionSlug?",
    name: "GeneralListingSignUp",
    component: () => import("@/components/GeneralListingSignUpComponent.vue"),
    props: true,
    meta: {
      title: "Create Listing",
      parent: "GeneralSectionsListComponent",
    },
  },
  // Route for Property for Rent Listing
  {
    path: "/property-for-rent-listing",
    name: "PropertyForRentListing",
    component: () => import("@/components/PropertyForRentListing.vue"),
    meta: {
      title: "Property for Rent Listing",
      parent: "GeneralGroupsListComponent",
    },
  },

  {
    path: "/search",
    name: "searchResults",
    component: () => import("@/components/GeneralFiltersResultsPage.vue"),
    props: (route) => ({
      query: route.query.q,
      categoryId: route.query.category || route.query.categoryId, // Support both formats
      subcategoryId: route.query.subcategory || route.query.subcategoryId, // Support both formats
      groupId: route.query.group || route.query.groupId, // NEW: Add groupId support
      sectionId: route.query.section,
      sortBy: route.query.sortBy || "newest",
      view: route.query.view || "grid",
      source: route.query.source, // Track where the search came from
    }),
  },

  {
    path: "/property-filter/:categorySlug",
    name: "PropertyFilter",
    component: () =>
      import("@/components/GeneralPropertySearchFilterComponent.vue"),
    props: (route) => ({
      categorySlug: route.params.categorySlug,
      categoryId: route.query.categoryId,
    }),
    meta: {
      title: (route) =>
        `${route.params.categorySlug
          .split("-")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ")}`,
      breadcrumb: true,
    },
  },

  {
    path: "/property-search/:categorySlug?",
    name: "PropertySearch",
    component: () =>
      import("@/components/PropertySearchResultParentComponent.vue"),
    props: (route) => ({
      categorySlug: route.params.categorySlug,
      // NEW: Add support for query-based filtering from header navigation
      categoryId: route.query.categoryId,
      subcategoryId: route.query.subcategoryId,
      groupId: route.query.groupId,
      source: route.query.source,
    }),
    meta: {
      requiresAuth: false,
      title: "Property Search Results",
    },
  },

  {
    path: "/property-search/:categorySlug/:subcategorySlug?",
    name: "PropertySearchWithSubcategory",
    component: () =>
      import("@/components/PropertySearchResultParentComponent.vue"),
    props: (route) => ({
      categorySlug: route.params.categorySlug,
      subcategorySlug: route.params.subcategorySlug,
      // NEW: Add support for query-based group filtering from header
      categoryId: route.query.categoryId,
      subcategoryId: route.query.subcategoryId,
      groupId: route.query.groupId,
      source: route.query.source,
    }),
    meta: {
      requiresAuth: false,
      title: "Property Search Results",
    },
  },

  {
    path: "/listing/:id/:slug?",
    name: "ListingDetails",
    component: () => import("@/components/DetailsListingView.vue"),
    props: true,
    meta: {
      title: "Listing Details",
    },
  },

  {
    path: "/listing/:id/:slug?/:listingId/jobs",
    // This route is specifically for jobs, so we can have a different component
    name: "ListingDetailsForJobs",
    component: () => import("@/components/Jobs/DetailsListingViewForJob.vue"),
    props: true,
    meta: {
      title: "Listing Details",
    },
  },

  {
    path: "/my-searches",
    name: "mySearches",
    component: () => import("@/views/MySearches.vue"), // Create this component
    meta: { requiresAuth: true },
  },

  {
    path: "/success",
    name: "SuccessPage",
    component: () => import("@/views/SuccessPage.vue"), // Create this component
  },
  {
    path: "/select-your-city",
    name: "SelectYourCity",
    component: SelectYourCity,
    meta: { category: "location", subcategory: "city-selection" },
    props: false,
  },

  // 📌 Authentication Routes
  {
    path: "/auth-list",
    name: "Aunthentication",
    component: authComponent,
    props: false,
  },
  {
    path: "/login",
    name: "Login",
    component: LoginPage,
    props: false,
  },
  {
    path: "/admin-login",
    name: "AdminLoginPage",
    component: AdminLoginPage,
    props: false,
  },
  {
    path: "/forgotten-password",
    name: "ForgottenPassword",
    component: ForgottenPassword,
    props: false,
  },
  {
    path: "/reset-password",
    name: "ResetPassword",
    component: ResetPassword,
    props: false,
  },
  {
    path: "/product",
    name: "ProductView",
    component: ProductView,
    props: false,
  },
  {
    path: "/list",
    name: "list",
    component: () => import("@/views/ListView.vue"),
    props: (route) => ({ query: route.query }),
  },

  {
    path: "/properties/list",
    name: "PropertiesList",
    component: () => import("@/views/PropertyFilterReDo.vue"),
  },
  {
    path: "/create-listing/:categoryName",
    name: "CreateListing",
    component: () => import("@/views/CreateListing.vue"),
    props: true,
  },
  {
    path: "/login/:provider",
    name: "SocialOauthCallback",
    component: () => import("@/components/auth/SocialOauthCallback.vue"),
    props: true,
  },
  {
    path: "/verify",
    name: "VerifyEmail",
    component: VerifyEmail,
    props: false,
  },
  {
    path: "/verify-user",
    name: "VerifyUser",
    component: VerifyUser,
    props: false,
  },
  // 📌 Listings
  {
    path: "/place-ad",
    name: "PlaceAd",
    component: PlaceAd,
    meta: { title: "Home" }, // Set PlaceAd as the Home route
    //props: false,
  },

  {
    path: "/my-ads-listings",
    name: "MyAdsListings",
    component: () => import("@/components/MyUserListings.vue"),
    meta: { requiresAuth: true },
    props: false,
  },
  {
    path: "/my-ads",
    name: "MyAds",
    component: MyAds,
    props: false,
  },
  {
    path: "/register",
    name: "Register",
    component: RegisterComponent,
    props: false,
  },
  {
    path: "/terms",
    name: "term",
    component: TermsComponent,
    props: false,
  },
  {
    path: "/policies",
    name: "policies",
    component: PolicyComponent,
    props: false,
  },
  {
    path: "/ats/user_type",
    name: "GuestDashboard",
    component: GuestDashboard,
    meta: { requiresAuth: true },
    props: false,
  },

  {
    path: "/ats/profile",
    name: "GuestProfile",
    component: GuestDashboard, // same component that toggles between cards & forms
    meta: { requiresAuth: true },
    // so you can pick up `user_type` in props if you ever want to
    props: (route) => ({ userType: route.query.user_type }),
  },

  {
    path: "/ats/overview",
    name: "Overview",
    component: GuestDashboard,
    meta: { requiresAuth: true },
  },

  {
    path: "/ats/jobs-dashboard",
    name: "JobsDashboard",
    component: GuestDashboard,
    meta: { requiresAuth: true },
  },

  {
    path: "/ats/jobs/applications",
    name: "JobApplications",
    component: GuestDashboard,
    meta: { requiresAuth: true },
  },

  {
    path: "/ats/candidate-search",
    name: "CandidateSearch",
    component: GuestDashboard,
    meta: { requiresAuth: true },
  },

  {
    path: "/ats/pick-subcategory/:subcategory",
    name: "PickSubCategoryForJob",
    component: () => import("@/components/Dashboard/GuestDashboard.vue"),
    meta: {
      title: (route) =>
        route.params.subcategory.charAt(0).toUpperCase() +
        route.params.subcategory.slice(1), // Dynamically set the category name
      parent: "PlaceAnAdForJob",
    },
  },

  { path: "/ats/place-an-ad", name: "PlaceAnAd", component: GuestDashboard },

  {
    path: "/ats/select-your-city",
    name: "SelectYourCityForJobAd",
    component: GuestDashboard,
    meta: {
      category: "location",
      subcategory: "city-selection",
      requiresAuth: true,
    },
    props: false,
  },

  {
    // Change from /group-list/11?categoryId=4 to /group-list/subcategory-name
    path: "/ats/group-list/:subcategorySlug",
    name: "GeneralGroupsListComponentForJob",
    component: () => import("@/components/Dashboard/GuestDashboard.vue"),
    props: (route) => ({
      subcategorySlug: route.params.subcategorySlug,
      categorySlug: route.query.category,
    }),
    meta: {
      title: (route) => `Select Group`,
      parent: "PickSubCategoryForJob",
    },
  },

  {
    // Change from /section-list/33 to /section-list/group-name
    path: "/ats/section-list/:groupSlug",
    name: "GeneralSectionsListComponentForJob",
    component: () => import("@/components/Dashboard/GuestDashboard.vue"),
    props: (route) => ({
      groupSlug: route.params.groupSlug,
      categorySlug: route.query.category,
      subcategorySlug: route.query.subcategory,
    }),
    meta: {
      title: (route) => `Select Section`,
      parent: "GeneralGroupsListComponentForJob",
    },
  },

  {
    // Change from /listing-signup/4/11/33 to /listing-signup/category/subcategory/group/section
    path: "/ats/listing-signup/:categorySlug?/:subcategorySlug?/:groupSlug?/:sectionSlug?",
    name: "GeneralListingSignUpForJob",
    component: () => import("@/components/Dashboard/GuestDashboard.vue"),
    props: true,
    meta: {
      title: "Create Listing",
      parent: "GeneralSectionsListComponentForJob",
    },
  },

  {
    path: "/ats/success",
    name: "SuccessPageForJob",
    component: () => import("@/components/Dashboard/GuestDashboard.vue"), // Create this component
  },

  {
    path: "/ats/car-signup",
    name: "CarSignUpFormForJob",
    component: GuestDashboard,
    meta: { title: "Car Sign Up", parent: "SubcategoryList" }, // Child of Subcategories
  },
  // …

  {
    path: "/notification",
    name: "MyNotifications",
    component: MyNotifications,
    props: false,
  },

  {
    path: "/notifications",
    name: "NotificationsPage",
    component: () => import("@/components/notifications/NotificationsPage.vue"),
    meta: { requiresAuth: true },
  },

  {
    path: "/chats",
    name: "ChatsList",
    component: ChatView,
    meta: { requiresAuth: true },
  },
  {
    path: "/chat/:listingId/:sellerId",
    name: "ChatWindow",
    component: ChatView,
    meta: { requiresAuth: true },
    props: true,
  },

  {
    path: "/favorites",
    name: "Favorites",
    component: FavoritesComponent,
    meta: { requiresAuth: true },
  },

  //Jobs Module

  {
    path: "/jobs",
    name: "Jobs",
    component: JobsPageComponent,
  },

  {
    path: "/my-profile",
    name: "MyProfile",
    component: Profile,
    meta: { requiresAuth: true },
  },

  {
    path: "/admin",
    name: "AdminDashboard",
    component: AdminDashboard,
    props: false,
    meta: { requiresAuth: true, requiresAdmin: true },
    children: [
      {
        path: "/admin",
        name: "DashboardView",
        component: DashboardView,

        props: false,
      },
      {
        path: "/listings",
        name: "Listings",
        component: ListingsView,

        props: false,
      },

      {
        path: "/listings/motors",
        name: "ListingsMotors",
        component: ListingsView,

        props: false,
      },

      {
        path: "/listings/jobs",
        name: "ListingsJobs",
        component: ListingsView,

        props: false,
      },

      {
        path: "/listings/property-for-sale",
        name: "ListingsPropertyForSale",
        component: ListingsView,

        props: false,
      },

      {
        path: "/listings/property-for-rent",
        name: "ListingsPropertyForRent",
        component: ListingsView,

        props: false,
      },

      {
        path: "/listings/community",
        name: "ListingsCommunity",
        component: ListingsView,

        props: false,
      },

      {
        path: "/listings/classifieds",
        name: "ListingsClassifieds",
        component: ListingsView,

        props: false,
      },

      {
        path: "/listings/funiture-and-garden",
        name: "ListingsFunitureGarden",
        component: ListingsView,

        props: false,
      },

      {
        path: "/listings/mobile-and-tablets",
        name: "ListingsMobileTablets",
        component: ListingsView,

        props: false,
      },

      {
        path: "/listings-reported",
        name: "Listings Reported",
        component: ListingsReportedView,

        props: false,
      },

      {
        path: "/listings/:id",
        name: "ListingDetail",
        component: ListingDetailView,
        props: true,
      },
      {
        path: "/listing-cost",
        name: "ListingCost",
        component: ListingCost,

        props: false,
      },
      {
        path: "/users",
        name: "Users",
        component: UsersView,

        props: false,
      },
      {
        path: "/roles",
        name: "Roles",
        component: RolesView,

        props: false,
      },
      {
        path: "/permissions",
        name: "Permissions",
        component: PermissionsView,

        props: false,
      },
      {
        path: "/transactions",
        name: "Transactions",
        component: TransactionsView,

        props: false,
      },
      {
        path: "/categories",
        name: "Categories",
        component: CategoriesView,

        props: false,
      },
      {
        path: "/sub-categories",
        name: "Subcategories",
        component: SubcategoriesView,

        props: false,
      },
      {
        path: "/groups",
        name: "Groups",
        component: GroupsView,

        props: false,
      },
      {
        path: "/sections",
        name: "Sections",
        component: SectionView,

        props: false,
      },

      {
        path: "/countries",
        name: "Countries",
        component: CountriesView,

        props: false,
      },

      {
        path: "/cities",
        name: "Cities",
        component: CitiesView,

        props: false,
      },
    ],
  },
  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "about" */ "../views/AboutView.vue");
    },
  },
];

const router = createRouter({
  mode: history,
  history: createWebHistory(),
  routes,
});

// Helper function to slugify text
const slugify = (text) => {
  if (!text) return "";
  return text
    .toString()
    .toLowerCase()
    .trim()
    .replace(/\s+/g, "-")
    .replace(/[^\w\-]+/g, "")
    .replace(/\-\-+/g, "-");
};

// Helper function to find entity by ID or slug
const findEntity = (collection, id, slug) => {
  if (id && !isNaN(parseInt(id))) {
    return collection.find((item) => item.id === parseInt(id));
  }
  if (slug) {
    return collection.find(
      (item) => item.slug === slug || slugify(item.title || item.name) === slug
    );
  }
  return null;
};

// 📌 Main Navigation Guard
router.beforeEach(async (to, from, next) => {
  console.log("[ROUTE GUARD] STARTING Navigation to:", to.fullPath);

  // ✅ ENHANCED: Cleanup when leaving property search for ANY general search context
  const isLeavingPropertySearch =
    from.path.includes("/property-search") ||
    from.name === "PropertySearch" ||
    from.name === "PropertyFilter";

  const isGoingToGeneralSearch =
    to.path === "/search" ||
    to.name === "searchResults" ||
    (to.path === "/" && (to.query?.q || to.query?.categoryId)); // Home page with search params

  const isGoingToHomeWithSearch =
    to.path === "/" && (to.query?.q || to.query?.categoryId);

  // ✅ CRITICAL: Cleanup when transitioning from property search to general search OR home with search
  if (
    isLeavingPropertySearch &&
    (isGoingToGeneralSearch || isGoingToHomeWithSearch)
  ) {
    try {
      console.log(
        "[ROUTE GUARD] Cleaning up property search state for general search transition"
      );
      await store.dispatch("NewCategory/clearAllCategoryState");
      await store.dispatch("propertyFilter/resetFilters");

      // Also clear any lingering filters in the general filter store
      await store.dispatch("FilterStore/resetFilters");
    } catch (error) {
      console.warn("Navigation guard cleanup error:", error);
    }
  }

  const breadcrumbs = [];
  const currentPath = to.path;
  const isSearchRoute = to.name === "searchResults";

  // Add root breadcrumb
  const rootBreadcrumb = {
    title: "Home",
    to: isSearchRoute ? "/" : "/place-ad",
  };

  breadcrumbs.push(rootBreadcrumb);

  // Get params from both route params and query params
  const params = {
    categoryId: to.params.categoryId || to.query.categoryId,
    subcategoryId: to.params.subcategoryId || to.query.subcategoryId,
    groupId: to.params.groupId || to.query.groupId,
    sectionId: to.params.sectionId || to.query.sectionId,
    categorySlug: to.params.categorySlug,
    subcategorySlug: to.params.subcategorySlug,
    groupSlug: to.params.groupSlug,
    sectionSlug: to.params.sectionSlug,
  };

  // 1. Add category breadcrumb
  let category = null;
  if (params.categoryId || params.categorySlug) {
    try {
      category = findEntity(
        store.state.NewCategory.categories,
        params.categoryId,
        params.categorySlug
      );

      if (!category && params.categoryId) {
        // Try to fetch if not found
        const categoryName = await store.dispatch(
          "NewCategory/fetchCategoryName",
          parseInt(params.categoryId)
        );
        if (categoryName) {
          category = {
            id: params.categoryId,
            name: categoryName,
            slug: params.categorySlug || slugify(categoryName),
          };
        }
      }

      if (category) {
        breadcrumbs.push({
          title: category.name,
          to: {
            name: "PickSubCategory",
            params: { subcategory: category.slug },
          },
        });
      }
    } catch (error) {
      console.error("Error processing category for breadcrumbs:", error);
    }
  }

  // 2. Add subcategory breadcrumb
  let subcategory = null;
  if (params.subcategoryId || params.subcategorySlug) {
    try {
      subcategory = findEntity(
        store.state.NewCategory.subcategories,
        params.subcategoryId,
        params.subcategorySlug
      );

      if (!subcategory && params.subcategoryId) {
        // Try to fetch if not found
        const subcategoryName = await store.dispatch(
          "NewCategory/fetchSubcategoryName",
          parseInt(params.subcategoryId)
        );
        if (subcategoryName) {
          subcategory = {
            id: params.subcategoryId,
            title: subcategoryName,
            slug: params.subcategorySlug || slugify(subcategoryName),
          };
        }
      }

      if (subcategory) {
        const subcategorySlug = subcategory.slug || slugify(subcategory.title);

        breadcrumbs.push({
          title: subcategory.title,
          to: {
            name: "GeneralGroupsListComponent",
            params: { subcategorySlug: subcategorySlug },
            query: { category: category?.slug },
          },
        });
      }
    } catch (error) {
      console.error("Error processing subcategory for breadcrumbs:", error);
    }
  }

  // 3. Add group breadcrumb
  let group = null;
  if (params.groupId || params.groupSlug) {
    try {
      group = findEntity(
        store.state.NewCategory.groups,
        params.groupId,
        params.groupSlug
      );

      if (!group && params.groupId) {
        const groupName = await store.dispatch(
          "NewCategory/fetchGroupName",
          parseInt(params.groupId)
        );
        if (groupName) {
          group = {
            id: params.groupId,
            title: groupName,
            slug: params.groupSlug || slugify(groupName),
          };
        }
      }

      if (group) {
        const groupSlug = group.slug || slugify(group.title);

        breadcrumbs.push({
          title: group.title,
          to: {
            name: "GeneralSectionsListComponent",
            params: { groupSlug: groupSlug },
            query: {
              category: category?.slug,
              subcategory:
                subcategory?.slug || slugify(subcategory?.title || ""),
            },
          },
        });
      }
    } catch (error) {
      console.error("Error processing group for breadcrumbs:", error);
    }
  }

  // 4. Add section breadcrumb
  if (
    (params.sectionId || params.sectionSlug) &&
    params.sectionId !== "null" &&
    params.sectionSlug !== "null"
  ) {
    try {
      // Try to get section from the currently selected group's sections
      let section = null;

      if (group && group.sections) {
        section = findEntity(
          group.sections,
          params.sectionId,
          params.sectionSlug
        );
      }

      if (!section && params.sectionId) {
        const sectionName = await store.dispatch(
          "NewCategory/fetchSectionName",
          parseInt(params.sectionId)
        );
        if (sectionName) {
          section = {
            id: params.sectionId,
            title: sectionName,
            slug: params.sectionSlug || slugify(sectionName),
          };
        }
      }

      if (section) {
        // For the section level we point to the current page
        breadcrumbs.push({
          title: section.title,
          to: null, // Current page, so no navigation
        });
      }
    } catch (error) {
      console.error("Error processing section for breadcrumbs:", error);
    }
  }

  // 5. Add current page title if defined in route meta and not already added
  if (
    to.meta &&
    to.meta.title &&
    (breadcrumbs.length === 1 ||
      (breadcrumbs.length > 1 &&
        breadcrumbs[breadcrumbs.length - 1].title !== to.meta.title))
  ) {
    const title =
      typeof to.meta.title === "function" ? to.meta.title(to) : to.meta.title;

    breadcrumbs.push({
      title: title,
      to: null, // Current page, so no navigation
    });
  }

  // Dispatch to Vuex to update the breadcrumbs in the store
  store.dispatch("breadcrumbs/updateBreadcrumbs", breadcrumbs);

  // Auth check
  if (to.meta.requiresAuth && !store.state.auth.status.loggedIn) {
    return next({ name: "Login" });
  }

  if (to.meta.requiresAdmin) {
    if (store.state.auth.user?.role?.title !== "Admin") {
      // Optionally show an unauthorized message
      return next({
        name: "Home",
        query: { unauthorized: "true" },
      });
    }
  }

  console.log("[ROUTE GUARD] FINISHING Navigation to:", to.fullPath);
  console.log(
    "[ROUTE GUARD] Final query params:",
    JSON.parse(JSON.stringify(to.query))
  );

  next();
});

export default router;
